import React, { memo, useContext, useCallback } from 'react';
import { createBrowserHistory } from 'history';
import Template from '@olxeu-a2b/ui/src/commons/components/Template';
import { getConfig } from '@olxeu-a2b/delivery-utils/src/extras';
import { useViewport } from '@olxeu-a2b/delivery-utils/src/hooks';
import PageErrorBoundary from '../../utils/Components/PageErrorBoundary';
import Routes from '../../routes';
import TemplateContext from '../../contexts/TemplateContext';

const config = getConfig();
const history = createBrowserHistory();

function ContextualTemplate() {
  const viewport = useViewport();

  const {
    templateInfo: { title, subTitle, noMobileHeader, forceDesktop, onBack },
  } = useContext(TemplateContext);

  const onBackClick = useCallback(
    ev => {
      if (onBack) {
        onBack(ev, history);
      } else {
        history.goBack();
      }
    },
    [onBack],
  );

  return (
    <Template
      title={title}
      subTitle={subTitle}
      noMobileHeader={noMobileHeader}
      forceDesktop={forceDesktop}
      config={config}
      desktop={viewport.desktop}
      onBackClick={onBackClick}
    >
      <PageErrorBoundary>
        <Routes history={history} />
      </PageErrorBoundary>
    </Template>
  );
}

export default memo(ContextualTemplate);
